var map = {
	"./ai-insights/en_US.json": [
		47837,
		"src_assets_locale_ai-insights_en_US_json"
	],
	"./ai-insights/id_ID.json": [
		87893,
		"src_assets_locale_ai-insights_id_ID_json"
	],
	"./billing/en_US.json": [
		60395,
		"src_assets_locale_billing_en_US_json"
	],
	"./billing/id_ID.json": [
		21179,
		"src_assets_locale_billing_id_ID_json"
	],
	"./central-menu-management/en_US.json": [
		96384,
		"src_assets_locale_central-menu-management_en_US_json"
	],
	"./central-menu-management/id_ID.json": [
		96333,
		"src_assets_locale_central-menu-management_id_ID_json"
	],
	"./collection-infrastructure/en_US.json": [
		58624,
		"src_assets_locale_collection-infrastructure_en_US_json"
	],
	"./collection-infrastructure/id_ID.json": [
		991,
		"src_assets_locale_collection-infrastructure_id_ID_json"
	],
	"./customer-display/en_US.json": [
		26231,
		"src_assets_locale_customer-display_en_US_json"
	],
	"./customer-display/id_ID.json": [
		20951,
		"src_assets_locale_customer-display_id_ID_json"
	],
	"./e-invoice/en_US.json": [
		37658,
		"src_assets_locale_e-invoice_en_US_json"
	],
	"./ee-hq/en_US.json": [
		39568,
		"src_assets_locale_ee-hq_en_US_json"
	],
	"./ee-hq/id_ID.json": [
		30880,
		"src_assets_locale_ee-hq_id_ID_json"
	],
	"./en_US.json": [
		32424,
		"src_assets_locale_en_US_json"
	],
	"./help-center/en_US.json": [
		44539,
		"src_assets_locale_help-center_en_US_json"
	],
	"./help-center/id_ID.json": [
		6056,
		"src_assets_locale_help-center_id_ID_json"
	],
	"./hq-outlets/en_US.json": [
		51912,
		"src_assets_locale_hq-outlets_en_US_json"
	],
	"./hq-outlets/id_ID.json": [
		90185,
		"src_assets_locale_hq-outlets_id_ID_json"
	],
	"./id_ID.json": [
		72201,
		"src_assets_locale_id_ID_json"
	],
	"./integrations/en_US.json": [
		61974,
		"src_assets_locale_integrations_en_US_json"
	],
	"./integrations/id_ID.json": [
		22379,
		"src_assets_locale_integrations_id_ID_json"
	],
	"./inventory/en_US.json": [
		88215,
		"src_assets_locale_inventory_en_US_json"
	],
	"./inventory/id_ID.json": [
		70130,
		"src_assets_locale_inventory_id_ID_json"
	],
	"./invoice/en_US.json": [
		97104,
		"src_assets_locale_invoice_en_US_json"
	],
	"./invoice/id_ID.json": [
		59661,
		"src_assets_locale_invoice_id_ID_json"
	],
	"./library/en_US.json": [
		31034,
		"src_assets_locale_library_en_US_json"
	],
	"./library/id_ID.json": [
		45025,
		"src_assets_locale_library_id_ID_json"
	],
	"./lock/en_US.json": [
		19188,
		"src_assets_locale_lock_en_US_json"
	],
	"./lock/id_ID.json": [
		58828,
		"src_assets_locale_lock_id_ID_json"
	],
	"./login/en_US.json": [
		67064,
		"src_assets_locale_login_en_US_json"
	],
	"./login/id_ID.json": [
		10846,
		"src_assets_locale_login_id_ID_json"
	],
	"./loyalty/en_US.json": [
		94264,
		"src_assets_locale_loyalty_en_US_json"
	],
	"./loyalty/id_ID.json": [
		82340,
		"src_assets_locale_loyalty_id_ID_json"
	],
	"./marketing/en_US.json": [
		42040,
		"src_assets_locale_marketing_en_US_json"
	],
	"./marketing/id_ID.json": [
		31360,
		"src_assets_locale_marketing_id_ID_json"
	],
	"./menudishes/en_US.json": [
		33582,
		"src_assets_locale_menudishes_en_US_json"
	],
	"./menudishes/id_ID.json": [
		41734,
		"src_assets_locale_menudishes_id_ID_json"
	],
	"./no-permission/en_US.json": [
		23696,
		"src_assets_locale_no-permission_en_US_json"
	],
	"./no-permission/id_ID.json": [
		30073,
		"src_assets_locale_no-permission_id_ID_json"
	],
	"./order-status/en_US.json": [
		80061,
		"src_assets_locale_order-status_en_US_json"
	],
	"./order-status/id_ID.json": [
		71218,
		"src_assets_locale_order-status_id_ID_json"
	],
	"./order/en_US.json": [
		3091,
		"src_assets_locale_order_en_US_json"
	],
	"./order/id_ID.json": [
		37728,
		"src_assets_locale_order_id_ID_json"
	],
	"./other-tool/en_US.json": [
		18055,
		"src_assets_locale_other-tool_en_US_json"
	],
	"./payment-overdue/en_US.json": [
		7140,
		"src_assets_locale_payment-overdue_en_US_json"
	],
	"./payment-overdue/id_ID.json": [
		16751,
		"src_assets_locale_payment-overdue_id_ID_json"
	],
	"./pending-orders/en_US.json": [
		64860,
		"src_assets_locale_pending-orders_en_US_json"
	],
	"./pending-orders/id_ID.json": [
		67256,
		"src_assets_locale_pending-orders_id_ID_json"
	],
	"./pos/en_US.json": [
		99426,
		"src_assets_locale_pos_en_US_json"
	],
	"./pos/id_ID.json": [
		53061,
		"src_assets_locale_pos_id_ID_json"
	],
	"./promotions/en_US.json": [
		38998,
		"src_assets_locale_promotions_en_US_json"
	],
	"./promotions/id_ID.json": [
		55185,
		"src_assets_locale_promotions_id_ID_json"
	],
	"./referral/en_US.json": [
		45499,
		"src_assets_locale_referral_en_US_json"
	],
	"./referral/id_ID.json": [
		9725,
		"src_assets_locale_referral_id_ID_json"
	],
	"./restaurant-analytics/en_US.json": [
		74729,
		"src_assets_locale_restaurant-analytics_en_US_json"
	],
	"./restaurant-analytics/id_ID.json": [
		18270,
		"src_assets_locale_restaurant-analytics_id_ID_json"
	],
	"./restaurant-info/en_US.json": [
		36485,
		"src_assets_locale_restaurant-info_en_US_json"
	],
	"./restaurant-info/id_ID.json": [
		9619,
		"src_assets_locale_restaurant-info_id_ID_json"
	],
	"./sections-and-printers/en_US.json": [
		95589,
		"src_assets_locale_sections-and-printers_en_US_json"
	],
	"./sections-and-printers/id_ID.json": [
		38908,
		"src_assets_locale_sections-and-printers_id_ID_json"
	],
	"./settlement/en_US.json": [
		56829,
		"src_assets_locale_settlement_en_US_json"
	],
	"./settlement/id_ID.json": [
		34053,
		"src_assets_locale_settlement_id_ID_json"
	],
	"./shared/en_US.json": [
		95798,
		"src_assets_locale_shared_en_US_json"
	],
	"./shared/id_ID.json": [
		14842,
		"src_assets_locale_shared_id_ID_json"
	],
	"./staff-center/en_US.json": [
		42108,
		"src_assets_locale_staff-center_en_US_json"
	],
	"./staff-center/id_ID.json": [
		59342,
		"src_assets_locale_staff-center_id_ID_json"
	],
	"./table-bookings/en_US.json": [
		38664,
		"src_assets_locale_table-bookings_en_US_json"
	],
	"./table-bookings/id_ID.json": [
		55531,
		"src_assets_locale_table-bookings_id_ID_json"
	],
	"./tables-layout/en_US.json": [
		80511,
		"src_assets_locale_tables-layout_en_US_json"
	],
	"./tables-layout/id_ID.json": [
		28595,
		"src_assets_locale_tables-layout_id_ID_json"
	],
	"./void-dish/en_US.json": [
		15107,
		"src_assets_locale_void-dish_en_US_json"
	],
	"./void-dish/id_ID.json": [
		1158,
		"src_assets_locale_void-dish_id_ID_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 81067;
module.exports = webpackAsyncContext;